import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { DateProvider } from '../../../providers';
import LogoImg from './eurocopa.webp';
import {
  Body,
  Container,
  ColorsContainer,
  ColorsItem,
  Logo,
  Points,
  PointsContainer,
  Space,
  TeamColor,
  TeamName,
  Timer,
  Wrapper,
} from './styles';

function SoccerUefaEuro({ data }) {
  const { awayTeam, homeTeam, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '00:00';
    const [minutes, seconds] = DateProvider.getSoccerTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=KoHo&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Wrapper>
        <Logo src={LogoImg} />
        <Body>
          <Container>
            <Timer>{getTime()}</Timer>
            {homeTeam?.color && (
              <TeamColor style={{ background: homeTeam.color }} />
            )}
            {homeTeam?.colors && (
              <ColorsContainer>
                {homeTeam?.colors.map((color) => (
                  <ColorsItem
                    style={{ background: color.value }}
                    key={color.id}
                  />
                ))}
              </ColorsContainer>
            )}
            <TeamName>{homeTeam.name}</TeamName>
            <PointsContainer>
              <Points>{homeTeam.points}</Points>
              <Space>-</Space>
              <Points>{awayTeam.points}</Points>
            </PointsContainer>
            <TeamName>{awayTeam.name}</TeamName>
            {awayTeam?.color && (
              <TeamColor style={{ background: awayTeam.color }} />
            )}
            {awayTeam?.colors && (
              <ColorsContainer>
                {awayTeam?.colors.map((color) => (
                  <ColorsItem
                    style={{ background: color.value }}
                    key={color.id}
                  />
                ))}
              </ColorsContainer>
            )}
          </Container>
        </Body>
      </Wrapper>
    </>
  );
}

SoccerUefaEuro.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      color: PropTypes.string,
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      color: PropTypes.string,
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
};

SoccerUefaEuro.defaultProps = {
  data: {
    awayTeam: { colors: [{ id: 1, value: '#FCE822' }], name: 'SWE', points: 0 },
    homeTeam: { colors: [{ id: 1, value: '#E11828' }], name: 'ESP', points: 0 },
    time: [],
  },
};

export default SoccerUefaEuro;
